export class DocumentDBRestoreDestination {
    'region';
    'clusterIdentifier';
    'instanceClass';
    'instanceCount';
    'port';
    'subnetGroupName';
    'vpcSecurityGroupIds';
    'encryptionKey';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterIdentifier",
            "baseName": "clusterIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceClass",
            "baseName": "instanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceCount",
            "baseName": "instanceCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "subnetGroupName",
            "baseName": "subnetGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcSecurityGroupIds",
            "baseName": "vpcSecurityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DocumentDBRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
